const scope = {
    name_exists: 'Il nome dello scope {{name}} è già in uso',
    name_with_space: 'Il nome dello scope non può contenere spazi.',
};
export default Object.freeze(scope);
